import React, { FC } from "react";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { RateItemSchemaFormFieldsInfer } from "@sinch/components/application/RatelistBuilder/ratelistBuilderSchema";
import { useRateComponent } from "@sinch/components/application/RateComponent/UseRateComponent";
import { useRateBuilderSettings } from "@sinch/components/application/RatelistBuilder/UtilitiesProviders/RateBuilderSettingsProvider";
import { isBreakPenaltySourcedComponent } from "@sinch/components/application/Rate/useIntervalType";
import { useQueryHandler } from "@sinch/hooks/useQueryHandler";
import { RateIntervals } from "@sinch/components/application/RatelistBuilder/RateBuilderRowContent/IntervalSelect/queries.graphql";
import { RateIntervalsQuery } from "@sinch/components/application/RatelistBuilder/RateBuilderRowContent/IntervalSelect/queries.types";

export const ComponentOverview: FC<{ rate: RateItemSchemaFormFieldsInfer["rate"] }> = ({ rate }) => {
  const { t } = useTranslation();
  const { getLabel } = useRateComponent();
  const { rateType } = useRateBuilderSettings();
  const { data: intervalsData } = useQueryHandler<RateIntervalsQuery>(RateIntervals, { ratelistType: rateType });

  // A break penalty interval can report the penalty under the component of the rate it is valued from,
  // the row's own component is then calculated on evaluation - the same rule as in the editable row.
  const isCalculated = isBreakPenaltySourcedComponent(intervalsData?.rateIntervals, rate?.unit);
  const component = rate?.component;

  if (!isCalculated && !component) {
    return null;
  }

  return (
    <Stack direction="row" spacing={1} sx={{ height: "100%", alignItems: "flex-end", justifyContent: "flex-end" }}>
      {isCalculated ? (
        <Typography sx={{ color: "text.secondary" }}>{t("RateBuilder.calculated")}</Typography>
      ) : (
        <Typography>{getLabel(component)}</Typography>
      )}
    </Stack>
  );
};
